import { Star } from "lucide-react";

type Props = {
  value: number; // ví dụ 4.8
};

const StarRating = ({ value }: Props) => {
  const fullStars = Math.floor(value);
  const hasHalfStar = value - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex items-center">
      {/* Full stars */}
      {Array.from({ length: fullStars }).map((_, i) => (
        <Star key={`full-${i}`} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
      ))}

      {/* Half star */}
      {hasHalfStar && (
        <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 opacity-50" />
      )}

      {/* Empty stars */}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <Star key={`empty-${i}`} className="w-4 h-4 text-gray-300" />
      ))}
    </div>
  );
};

export default StarRating;